import { useMemo } from 'react'
import sortBy from 'lodash/sortBy'
import type { ListFieldConfig } from '@ztechapps/common.hook'

export const useBuildTableName = (name: string, fields: ListFieldConfig): string => {
  //build the table name base on the fields names or the provided
  const defaultName = useMemo(() => {
    if (!fields) return 'NO_NAME'
    return sortBy(Object.keys(fields)).join('_')
  }, [fields])
  name = name ?? defaultName
  name = `table__${name}`

  return name
}
